<div class="container-fluid">
  <h2>Page Not found</h2>
  <hr />

  <p>Sorry, but that link is not available in this application</p>
</div>
